module.exports = __webpack_public_path__ + "static/media/1012521.46358665.png";